<template>
  <portlet
    :icon="'fad fa-folder-open'"
    :title="'Plaatsingen'"
    :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <a
        :href="$CLOUD_API+'/export/placements?from=customerId&id=' + customer.id + '&access_token=' + this.$store.state.oAuthToken"
        v-if="this.$store.state.users.me.admin">
        <button class="btn btn-primary">
          <i class="fas fa-file-excel mr-2"></i> Exporteren naar Excel
        </button>
      </a>
    </template>
    <template slot="portletBody">
      <div class="table-responsive vacancy-info">
        <table class="table dataTable table-bordered table-striped"
               v-if="getCustomerPlacements(customer.id).length !== 0">
          <thead>
          <tr>
            <th>Persoon</th>
            <th>Salaris (p/u)</th>
            <th>Begin datum</th>
            <th>Einddatum</th>
            <th>Pensioen</th>
            <th>Opties</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(placement, index) in getCustomerPlacements(customer.id)" :key="placement.id">
            <td>
              <router-link v-if="getCandidate(placement.candidateId)" :to="'/candidates/'+ placement.candidateId">{{getFullName(placement.candidateId)}}
              </router-link>
              <span v-else>Verwijderde kandidaat</span>
            </td>
            <td>€ {{placement.hourlyWage}}</td>
            <td>{{placement.startDate|day}}</td>
            <td>
              <template v-if="placement.endDate">{{placement.endDate|day}}</template>
              <template v-else></template>
            </td>
            <td>{{placement.retirement}}</td>
            <td class="td-actions actions-column">
              <edit-candidate-placing
                :index="index"
                :title="'Plaatsing aanpassen'"
                :placement="placement"
                :name="'placement'"
                @saveChanges="editPlacement($event)"
              ></edit-candidate-placing>
              <a href="javascript:;" class="action-icon" @click="syncWithHourApp(placement)">
                <i class="far fa-mobile" title="Sync met hour app"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from "vuex";
  import editCandidatePlacing from "../editCandidatePlacing";
  import Vue from 'vue';
  import { buildEmploymentUpdatePayload, syncPlacementToHourApp } from "@/utils/placementSync";
  import { takenOverChange } from "@/utils/placementTakeover";

  export default {
    props: ["customer", "candidate"],
    components: {editCandidatePlacing},
    data() {
      return {
        placement: ""
      };
    },
    methods: {
      rowSelected(value) {
        this.modalId = value.id;
        this.placement = {id: this.modalId, name: value.name, standard: value.standard};
      },
      getFullName(id) {
        const candidate = this.getCandidate(id);
        return candidate ? this.getCandidate(id).firstName + ' ' + this.getCandidate(id).lastName : 'Verwijderde kandidaat';
      },
      async syncWithHourApp(placement) {
        const outcome = await syncPlacementToHourApp(this.$store.dispatch, {
          ApiClient: Vue.prototype.$ApiClient,
          placement,
          candidate: this.getCandidate(placement.candidateId),
          customer: this.getCustomer(placement.customerId),
        });

        if (!outcome.ok) {
          this.$toasted.global.failedRequest({message: outcome.message});

          return;
        }

        this.$toasted.global.successRequest({
          message: "Plaatsing gesynced met hour app"
        });
      },
      editPlacement(placement) {
        if (placement.id) {
          let id = placement.id;

          if (placement.endDate) {
            placement.endDate = moment(placement.endDate).format("YYYY-MM-DD");
          }

          $(".modal").modal("hide");
          $(".modal-backdrop").remove();

          this.$toasted.global.successRequest({
            message: "Plaatsing aangepast"
          });

          let p = this.getPlacement(id)
          this.$store.dispatch("placements/set", {
            id,
            endDate: placement.endDate,
            hourlyWage: placement.hourlyWage,
            retirement: placement.retirement,
            ...takenOverChange(placement)
          }).then(() => {
            // Update flexworker in hour app
            this.$store.dispatch('employments/update', {ApiClient: Vue.prototype.$ApiClient, employment: buildEmploymentUpdatePayload({placement: p, endDate: placement.endDate})}).catch(() => {
              this.$toasted.global.failedRequest({
                message: "Plaatsing aangepast, maar synchronisatie met hour app is mislukt"
              });
            });
          });
        }
      },
      getPlacement(id) {
        return this.getCustomerPlacements(this.customer.id).find(p => p.id === id);
      },
      getCandidate(id) {
        return this.getCandidates.find(candidate => candidate.id === id);
      },
      getCustomer(id) {
        return this.getCustomers.find(customer => customer.id === id);
      },
    },
    computed: {
      ...mapGetters("placements", ["getCustomerPlacements"]),
      ...mapGetters("candidates", ["getCandidate"]),
      ...mapGetters("vacancies", ["getVacancyName"]),
      ...mapGetters("candidates", ["getCandidates"]),
      ...mapGetters("customers", ["getCustomers"]),
    },
  };
</script>
